import { render, staticRenderFns } from "./SpeakerSection.vue?vue&type=template&id=ba9e764e&scoped=true&"
import script from "./SpeakerSection.vue?vue&type=script&lang=js&"
export * from "./SpeakerSection.vue?vue&type=script&lang=js&"
import style0 from "./SpeakerSection.vue?vue&type=style&index=0&id=ba9e764e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba9e764e",
  null
  
)

export default component.exports